import { render, staticRenderFns } from "./TaskGraphPanel.vue?vue&type=template&id=36fcaf60&scoped=true"
import script from "./TaskGraphPanel.vue?vue&type=script&lang=js"
export * from "./TaskGraphPanel.vue?vue&type=script&lang=js"
import style0 from "./TaskGraphPanel.vue?vue&type=style&index=0&id=36fcaf60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36fcaf60",
  null
  
)

export default component.exports